import type { ColDef } from "ag-grid-enterprise";

// Weight (and similar numeric-looking) columns are pre-formatted strings (e.g. "10.00"),
// which AG-Grid's default sort compares lexicographically ("10.00" before "2.00").
function numberComparator(valueA: unknown, valueB: unknown): number {
  const a = Number(valueA);
  const b = Number(valueB);
  if (Number.isNaN(a) && Number.isNaN(b)) return 0;
  if (Number.isNaN(a)) return -1;
  if (Number.isNaN(b)) return 1;
  return a - b;
}

// Driven by colDef.context.numericSort rather than cellDataType: 'number' — the latter's
// built-in valueFormatter renders "Invalid Number" for our pre-formatted numeric strings.
export function withNumberComparator(columnDefs: ColDef[]): ColDef[] {
  return columnDefs.map((c) =>
    (c.context as Record<string, unknown> | undefined)?.numericSort
      ? { ...c, comparator: numberComparator }
      : c
  );
}
